import { IRawSectionTime } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class SectionTime implements IRawSectionTime {
  static build(sectionTime: IRawSectionTime) {
    return new SectionTime(sectionTime);
  }
  id: number;
  nk: string;
  section: number;
  day_of_week: number;
  location: number;
  from_tm: string;
  to_tm: string;
  from_dt: string;
  to_dt: string;

  constructor(sectionTime: IRawSectionTime) {
    _4.merge(this, sectionTime);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/builders/section_time_builder.ts